import { create } from "zustand";
import { InstalledIntegration, InstalledIntegrationType } from "@/types/installedintegration";

export type CalendarIntegrationType = InstalledIntegrationType.GOOGLECALENDAR | InstalledIntegrationType.MICROSOFTCALENDAR;

interface CalendarIntegrationsStore {
  // All connected calendar integrations
  calendarIds: InstalledIntegration[];

  // Load calendar integrations from installed integrations
  loadCalendarIds: (calendars: InstalledIntegration[]) => void;

  // Clear all calendar data
  reset: () => void;
}

export const useCalendarIntegrationsStore = create<CalendarIntegrationsStore>(
  (set) => ({
    calendarIds: [],

    loadCalendarIds: (calendars: InstalledIntegration[]) => {
      set({ calendarIds: calendars });
    },

    reset: () => {
      set({ calendarIds: [] });
    },
  })
);
